var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('div',[_vm._v(" Vous retrouverez ici les rapports utiles à la gestion des accès sur site. ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }